import { Injectable } from '@angular/core';
import { 
  CanActivate, 
  Router, 
  ActivatedRouteSnapshot, 
  UrlTree, 
  RouterStateSnapshot 
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, switchMap, filter } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService, 
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    
    // 1. EXCEPCIÓN: Permitir acceso a la ruta de seguimiento sin autenticación
    if (route.routeConfig?.path?.startsWith('track/')) {
      return of(true);
    }

    // 2. ESPERAR A FIRESTORE: Aseguramos que la sesión y el perfil estén cargados
    return this.authService.authStateReady$.pipe(
      filter(isReady => isReady === true),
      take(1),
      switchMap(() => {
        return this.authService.user$.pipe(
          take(1),
          map(user => {
            // Si no hay usuario, mandamos al login
            if (!user) {
              return this.router.createUrlTree(['/login']);
            }

            const isAccessingPortal = state.url.includes('/portal');
            const isClient = user.role === 'client';

            // 3. BLOQUEO DE CLIENTES EN ZONA TALLER:
            // Si el usuario es un 'client' e intenta entrar a una ruta administrativa,
            // lo forzamos a quedarse en su portal.
            if (isClient && !isAccessingPortal) {
              return this.router.createUrlTree(['/portal']);
            }

            // 4. PROTECCIÓN DEL TALLER PARA STAFF:
            // Si un empleado intenta entrar al portal (opcional, pero ayuda a la consistencia),
            // podrías dejarlo o mandarlo al home. Aquí permitimos que el staff vea el portal 
            // pero que el cliente NUNCA vea el taller.

            // 5. RESTRICCIÓN PARA GERENTES (Analytics):
            if (route.data['role'] === 'manager' && user.role !== 'manager') {
              return this.router.createUrlTree(['/home']);
            }

            return true;
          })
        );
      })
    );
  }
}